export const setCurrentWins = (newWins) => {
    const winsCookie = useCookie('currentWins');
    winsCookie.value = newWins;
};

export const clearCurrentWins = () => {
    const winsCookie = useCookie('currentWins');
    winsCookie.value = null;
};
